<template>
  <div class="download-buttons-container">
    <v-col>
      <h3>Apple Silicon Macs</h3>
      <button
        class="download-button apple-button"
        @click="downloadFile('AppleSilicon', 'MESArp-AppleSilicon-1.0.0.pkg')"
      >
        <img
          :src="require('../../../assets/apple-icon.svg')"
          alt="Download Mac Apple Silicon Demo"
        />
      </button>
      <br>
      <h3>Intel Macs</h3>
      <button
        class="download-button apple-button"
        @click="downloadFile('Intel', 'MESArp-Intel-1.0.0.pkg')"
      >
        <img
          :src="require('../../../assets/apple-icon.svg')"
          alt="Download Mac Intel Demo"
        />
      </button>
      <br>
      <h3>Windows</h3>
      <button
        class="download-button windows-button"
        @click="downloadFile('Windows', 'MESArp-Windows-1.0.0.exe')"
      >
        <img
          :src="require('../../../assets/windows-icon.svg')"
          alt="Download Windows Demo"
        />
      </button>
      <br>
      <br>
      <br>
      <p>The free versions have the following restrictions - arpeggiator output interruptions occur intermittently.</p>
    </v-col>
  </div>
</template>

  <script>
  export default {
    name: 'MesArpDownloadButtons',
    methods: {
      downloadFile (platform, fileName) {
        // Correct Cloud Function URL
        const functionEndpoint = 'https://us-central1-make-electronic-sound.cloudfunctions.net/annaliis-downloads'

        // Construct the download URL using the Cloud Function endpoint and the file name
        // Note: No need to add '/downloads/' since your function is not expecting it
        const downloadUrl = `${functionEndpoint}/${fileName}`

        // Redirect the user to the Cloud Function URL to trigger the download
        window.location.href = downloadUrl
      },
    },
  }
  </script>

<style>
.cta-buttons {
  display: flex;
  justify-content: center; /* Centering the buttons */
  padding: 20px;
  gap: 20px; /* Adds space between buttons */
}

.cta-button {
  padding: 10px 40px; /* Increased horizontal padding */
  border: none;
  border-radius: 5px;
  font-size: 18px; /* Slightly larger font size */
  cursor: pointer;
  transition: background-color 0.3s;
  min-width: 150px; /* Minimum width */
  background-color: #4CAF50; /* Green */
  color: white;
}
.download-buttons-container {
    display: flex;
    flex-direction: column;
    align-items: center; /* This centers the buttons horizontally */
    justify-content: center;
    padding: 20px;
}

.download-button {
    align-items: center;
    justify-content: center;
    margin: 10px 0; /* Adds margin above and below each button */
    padding: 10px 20px;
    text-decoration: none;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    transition: transform 0.3s ease;
    width: 320px; /* Set a fixed width for all buttons */
    text-align: center;
}

.download-button img {
    margin-right: 10px; /* Space between the image and the text */
    height: 30px;
    vertical-align: middle; /* Aligns the image with the text */
}

.download-button span {
    flex-grow: 1; /* Ensures the text takes up remaining space */
    text-align: left; /* Aligns the text to the left within the flex item */
}

.download-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
}

.apple-button { background-color: #f5f5f7; color: #000; }
.windows-button { background-color: #0074d4; color: #fff; }

.windows-button img {
    filter: brightness(0) invert(1); /* Inverts black to white */
}

/* Add other styles here if necessary */
</style>
